import { render, staticRenderFns } from "./DeliveryCalculateForm.vue?vue&type=template&id=56bbce5c&scoped=true&"
import script from "./DeliveryCalculateForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryCalculateForm.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryCalculateForm.vue?vue&type=style&index=0&id=56bbce5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bbce5c",
  null
  
)

export default component.exports